import { Sensors as SensorsIcon } from "@mui/icons-material";
import { Tooltip } from "@mui/material";

import { EVOTRUX_GREEN } from "constants/index";

interface Props {
  linkOffered: boolean;
}

const OFFERED_TOOLTIP =
  "This carrier offered a live tracking link on this quote";
const NOT_OFFERED_TOOLTIP =
  "This carrier did not offer a live tracking link on this quote. Every booking still gets tracking updates on Evotrux";

/**
 * Whether this quote came with an offer of a live tracking link. One icon, so
 * a shipper can read the column down rather than a sentence per row.
 */
export function QuoteTrackingLinkCell(props: Props) {
  const { linkOffered } = props;

  return (
    <Tooltip title={linkOffered ? OFFERED_TOOLTIP : NOT_OFFERED_TOOLTIP}>
      <SensorsIcon
        fontSize="small"
        // The icon carries no text, so the colour alone would be saying it. The
        // tooltip is the label, and it is on both states for that reason.
        aria-label={
          linkOffered ? "Tracking link offered" : "No tracking link offered"
        }
        sx={{ color: linkOffered ? EVOTRUX_GREEN : "grey.400" }}
      />
    </Tooltip>
  );
}
